import {createApi} from '@reduxjs/toolkit/query/react';

import {isNotNil} from 'ramda';

import {queryParams} from '../consts/queryParams';
import {dmsBaseQuery} from './dmsBaseQuery';
import {
  GetBusinessCaseOnlineOfferApiArg,
  GetBusinessCaseOnlineOfferApiResponse,
  GetPdfByOfferIdApiArg,
  GetPdfByOfferIdApiResponse,
  ListLogosApiArg,
  ListLogosApiResponse,
  SendOnlineOfferEngagementApiArg,
} from './types/onlineOfferTypes';

export const onlineOfferApi = createApi({
  baseQuery: dmsBaseQuery,
  reducerPath: 'onlineOfferApi',
  tagTypes: [],
  endpoints: (build) => ({
    getBusinessCaseOnlineOffer: build.query<
      GetBusinessCaseOnlineOfferApiResponse,
      GetBusinessCaseOnlineOfferApiArg
    >({
      query: (queryArg) => {
        const params = new URLSearchParams();
        if (isNotNil(queryArg.openedBy)) {
          params.set('openedBy', queryArg.openedBy);
        }
        if (isNotNil(queryArg.sessionId)) {
          params.set(queryParams.SESSION_ID, queryArg.sessionId);
        }
        const paramsToSet = params.toString();
        return {
          url: `/dms/v1/business-case/online-offer/${queryArg.offerId}/data${paramsToSet ? `?${paramsToSet}` : ''}`,
          headers: {'X-Workspace': queryArg.workspace},
        };
      },
    }),
    listLogos: build.query<ListLogosApiResponse, ListLogosApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/logo`,
        headers: {'X-Workspace': queryArg['X-Workspace']},
      }),
    }),
    getPdfByOfferId: build.query<GetPdfByOfferIdApiResponse, GetPdfByOfferIdApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/online-offer/${queryArg.offerId}/pdf`,
        params: {
          lang: queryArg.locale,
          filename: queryArg.filename,
          margin: '0px 0px 0px 0px',
          contentDisposition: 'attachment',
        },
        headers: {
          'X-Workspace': queryArg.workspace,
        },
      }),
    }),
    sendOnlineOfferEngagement: build.mutation<void, SendOnlineOfferEngagementApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/business-case/online-offer/${queryArg.offerId}/engagement`,
        method: 'POST',
        headers: {'X-Workspace': queryArg.workspace},
        body: {
          sessionId: queryArg.sessionId,
          activeTimeMs: queryArg.activeTimeMs,
          scrollDepth: queryArg.scrollDepth,
          certificateClick: queryArg.certificateClick,
        },
      }),
    }),
  }),
});

export const {
  useGetBusinessCaseOnlineOfferQuery,
  useListLogosQuery,
  useLazyGetPdfByOfferIdQuery,
  useSendOnlineOfferEngagementMutation,
} = onlineOfferApi;
